import type { PrizeType } from '../enums/PrizeType'

export class PrizeMiniEntity {
  id?: number
  name?: string | null
  type?: PrizeType
  createdAt?: string
  probability?: number
  order?: number
}
